module.exports = __webpack_public_path__ + "img/KS_Logo_Blau.55edb2df.png";